export const BID_NEW_SUIT_TWO_LEVEL = 'bid-options/response-after-nt-overcall/BID_NEW_SUIT_TWO_LEVEL';
export const RAISE_PARTNERS_SUIT_TO_TWO_LEVEL = 'bid-options/response-after-nt-overcall/RAISE_PARTNERS_SUIT_TO_TWO_LEVEL';
export const BID_TWO_NO_TRUMP = 'bid-options/response-after-nt-overcall/BID_TWO_NO_TRUMP';
export const PENALTY_DOUBLE = 'bid-options/response-after-nt-overcall/PENALTY_DOUBLE';
